import { useEffect, useState } from 'react';
import connectivity from '../utils/connectivity';
import syncService from '../services/syncService';

export default function OfflineIndicator() {
  const [isOnline,   setIsOnline]   = useState(true); // optimistic — confirmed by API calls
  const [syncStatus, setSyncStatus] = useState(null);
  const [showSynced, setShowSynced] = useState(false);

  useEffect(() => {
    const unsubC = connectivity.subscribe(({ online }) => setIsOnline(online));
    const unsubS = syncService.subscribe((s) => {
      setSyncStatus(s);
      if (s.status === 'synced' && s.completed > 0) {
        setShowSynced(true);
        setTimeout(() => setShowSynced(false), 3000);
      }
    });
    return () => { unsubC(); unsubS(); };
  }, []);

  if (isOnline && !syncStatus?.isSyncing && !showSynced) return null;

  const bar = (color, children) => (
    <div style={{
      background: `color-mix(in srgb, ${color} 12%, var(--surface))`,
      borderBottom: `1px solid color-mix(in srgb, ${color} 35%, var(--border))`,
      color, padding: '6px 16px', fontSize: 13,
      display: 'flex', alignItems: 'center', gap: 8,
      animation: 'sg-fade-up .2s var(--ease) both',
    }}>
      {children}
    </div>
  );

  return (
    <div style={{ flexShrink: 0 }}>
      {!isOnline && bar('var(--bad)',
        <>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--bad)', flexShrink: 0 }} />
          <span style={{ flex: 1, color: 'var(--text)' }}>Sin conexión — los cambios se sincronizarán al reconectar</span>
          <button
            onClick={() => connectivity._ping()}
            style={{
              background: 'color-mix(in srgb, var(--bad) 14%, transparent)',
              border: '1px solid color-mix(in srgb, var(--bad) 40%, transparent)',
              color: 'var(--bad)', borderRadius: 5, cursor: 'pointer',
              padding: '2px 10px', fontSize: 12, fontWeight: 700, flexShrink: 0,
              transition: 'transform .12s var(--ease)',
            }}
            onMouseDown={e => { e.currentTarget.style.transform = 'scale(.95)'; }}
            onMouseUp={e => { e.currentTarget.style.transform = 'none'; }}
          >
            Reintentar
          </button>
        </>
      )}
      {syncStatus?.isSyncing && bar('var(--info)',
        <span style={{ color: 'var(--text)' }}>⟳ Sincronizando... ({syncStatus.completed}/{syncStatus.queued})</span>
      )}
      {showSynced && !syncStatus?.isSyncing && bar('var(--ok)',
        <span style={{ color: 'var(--text)' }}>✓ {syncStatus?.completed} {syncStatus?.completed === 1 ? 'cambio sincronizado' : 'cambios sincronizados'}</span>
      )}
    </div>
  );
}
